import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const PATH_ICONS = [
  'ri-search-eye-line',
  'ri-building-2-line',
  'ri-git-branch-line',
  'ri-compass-discover-line',
];

export default function IntentPathwaysSection() {
  const { t } = useTranslation('home');
  const pathways = t('intentPathways.items', { returnObjects: true }) as Array<{
    label: string;
    title: string;
    description: string;
  }>;

  return (
    <section className="bg-[#FBF8F3] py-24 border-t border-[#E7E1D9]">
      <div className="max-w-[1440px] mx-auto px-8 lg:px-16">

        {/* Header */}
        <div className="max-w-[540px] mb-14">
          <p className="text-[11px] uppercase tracking-[0.12em] font-medium text-[#F97700] mb-4">
            {t('intentPathways.eyebrow')}
          </p>
          <h2 className="text-4xl font-semibold text-[#0B0B0B] leading-[1.2]">
            {t('intentPathways.title')}
          </h2>
        </div>

        {/* Pathways — 2 × 2 grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {Array.isArray(pathways) && pathways.map((item, i) => (
            <Link
              key={i}
              to="/diagnostico"
              className="group flex items-start gap-6 bg-white border border-[#E7E1D9] rounded-lg p-8 hover:border-[#F97700] transition-all duration-300 cursor-pointer"
            >
              {/* Icon block */}
              <div className="w-11 h-11 flex items-center justify-center flex-shrink-0 bg-[#FFF1E6] rounded group-hover:bg-[#F97700] transition-colors duration-300">
                <i className={`${PATH_ICONS[i]} text-xl text-[#F97700] group-hover:text-white transition-colors duration-300`}></i>
              </div>

              {/* Text */}
              <div className="flex-1 min-w-0">
                <p className="text-[10px] uppercase tracking-[0.1em] font-medium text-[#9A9288] mb-1.5">
                  {item.label}
                </p>
                <h3 className="text-[16px] font-semibold text-[#0B0B0B] mb-2 leading-snug group-hover:text-[#F97700] transition-colors duration-300">
                  {item.title}
                </h3>
                <p className="text-[13px] text-[#5A5248] leading-relaxed">
                  {item.description}
                </p>
              </div>

              {/* Arrow */}
              <div className="flex-shrink-0 w-7 h-7 flex items-center justify-center text-[#C8C0B4] group-hover:text-[#F97700] transition-colors duration-300">
                <i className="ri-arrow-right-line text-lg"></i>
              </div>
            </Link>
          ))}
        </div>

        {/* Soft note */}
        <p className="text-[12px] text-[#9A9288] mt-8 max-w-[560px] leading-relaxed">
          {t('intentPathways.note')}
        </p>
      </div>
    </section>
  );
}
